<template>
	<UserListModal :users="users" :user-type="userType">
		<template #button="{ on }">
			<tile-card
				:action-title="actionTitle"
				:aspect-ratio="3 / 2"
				@click="on.click"
			>
				<template #title>
					<v-list-item :two-line="!!overline">
						<v-list-item-content class="pb-0">
							<div v-if="!!overline" class="overline">{{ overline }}</div>
							<v-list-item-title class="headline">{{
								title || userType
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</template>

				<v-card-text class="py-0">
					<v-row v-for="(chunk, i) in chunks" :key="i">
						<v-col
							v-for="user in chunk"
							:key="user.guid"
							:cols="12 / usersPerRow"
						>
							<UserWidget :user="user" :overline="userOverline(user)" @click.stop />
						</v-col>
					</v-row>
				</v-card-text>
			</tile-card>
		</template>
	</UserListModal>
</template>

<script>
import TileCard from "../../shared/TileCard";
import UserWidget from "../../shared/UserWidget";

import UserListModal from "./UserListModal";

export default {
	components: { TileCard, UserWidget, UserListModal },

	props: {
		title: {
			type: String,
			required: false,
			default: null,
		},
		overline: {
			type: String,
			required: false,
			default: null,
		},
		showUserRelation: {
			type: Boolean,
			required: false,
			default: false,
		},
		userType: {
			type: String,
			required: true,
		},
		users: {
			type: Array,
			required: true,
		},
	},

	data: () => ({
		rows: 2,
		usersPerRow: 3,
	}),

	computed: {
		chunks() {
			const chunks = [];
			for (let i = 0; i < this.rows; i++) {
				const sliceStart = i * this.usersPerRow;
				const sliceEnd = (i + 1) * this.usersPerRow;
				chunks.push(this.users.slice(sliceStart, sliceEnd));
			}
			return chunks;
		},

		actionTitle() {
			if (this.userType === "Staff") {
				return `${this.users.length} ${this.userType}`;
			}
			return this.users
				.reduce(
					(types, user) => {
						// if user has a relationship, it is a guest
						const isMember = !user.relationship;
						types[isMember ? 0 : 1][1]++;
						return types;
					},
					[
						["Member", 0],
						["Guest", 0],
					]
				)
				.filter(([str, total]) => total)
				.map(([str, total]) => `${total} ${str}${total === 1 ? "" : "s"}`)
				.join(", ");
		},

		actionTarget() {
			const params = { communityId: this.$route.params.communityId };
			return {
				name: `Live Community ${this.userType}`,
				params,
			};
		},
	},

	methods: {
		userOverline(user) {
			return this.showUserRelation ? user.relationship || user.userType : null;
		},
	},
};
</script>
